import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import useSetState from '../../../hooks/useSetState';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ShowForPermission from '../../../components/ShowForPermission';
import ENUMS from '../../../enums';
import { addNewRegion, updateRegion } from '../../../redux/regions/actions';
import CreatableSelect from 'react-select/creatable';

const AddOrEditRegion = props => {
  const [displayModal, setDisplayModal] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const [controls, setControls] = useSetState({
    name: '',
    cityId: '',
    id: '',
    regionsList: [],
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const handleModal = () => setDisplayModal(!displayModal);

  const OnSubmitAddOrEditRegionForm = event => {
    event.preventDefault();
    let data = {};

    if (props.editMode) {
      data = {
        name: controls.name,
      };
      dispatch(updateRegion(data, controls.id))
        .then(res => console.log(res))
        .catch(error => console.log('error', error));
      handleModal();
    } else {
      data = { name: controls.name.value, cityId: controls.cityId };
      dispatch(addNewRegion(data))
        .then(res => {
          onChangeValue('regionsList', [...controls.regionsList, data.name]);
          onChangeValue('name', '');
        })
        .catch(error => console.log('error', error));
    }
  };

  useEffect(() => {
    onChangeValue('name', props.item?.name);
    onChangeValue('id', props.item?.id);
  }, []);

  useEffect(() => {
    onChangeValue('cityId', props.cityId);
  }, [props.cityId]);

  return (
    <section>
      <div className='col-12'>
        {props.editMode ? (
          <a className='pe-auto' href='#' title={locales('edit.region')}>
            <i
              className='text-center fa fa-pencil text-secondary pointer'
              onClick={handleModal}
            />
          </a>
        ) : (
          <>
            <div className='d-flex form-actions'>
              <ShowForPermission
                permission={ENUMS.PERMISSIONS.values.ADD_NEW_REGION}
              >
                <button onClick={handleModal} className='btn btn-primary mx-1'>
                  <i className='fa fa-plus mx-1' />
                  {locales('add.new.region')}
                </button>
              </ShowForPermission>
              <Link to='/cities-and-regions' className='btn btn-default'>
                <i className='fa fa-reply' />
                {locales('labels.back')}
              </Link>
            </div>
          </>
        )}
      </div>

      <Modal size='lg' isOpen={displayModal}>
        <ModalHeader className='page-header p-3'>
          <span className='panel-title'>
            <i className='fa fa-pencil' />
            {props.editMode
              ? locales('edit.region')
              : locales('add.new.region')}
          </span>
        </ModalHeader>

        <form
          onSubmit={OnSubmitAddOrEditRegionForm}
          id='addOrEditRegion'
          className='form-horizontal'
        >
          <ModalBody className='panel panel-default'>
            <div className='panel-body'>
              <div className='form-row'>
                <div className='form-group col-md-12 d-flex required'>
                  <label className='rsee-form-label col-3 text-right'>
                    {locales('region.name')}
                  </label>
                  <div className='full-width col-sm-6'>
                    <div className='full-width d-flex justify-content-start'>
                      {props.editMode ? (
                        <input
                          id='name'
                          name='name'
                          type='text'
                          placeholder={locales('region.name')}
                          className='form-control full-width'
                          value={controls.name}
                          onChange={e => onChangeValue('name', e.target.value)}
                        />
                      ) : (
                        <CreatableSelect
                          className='full-width'
                          id='name'
                          name='name'
                          isMulti={false}
                          isClearable={true}
                          onChange={e => onChangeValue('name', e)}
                          placeholder={locales('region.name')}
                          options={props.regionsNames?.map(item => ({
                            value: item.name,
                            label: item.name,
                          }))}
                        />
                      )}
                    </div>
                  </div>
                  <button
                    form='addOrEditRegion'
                    type='submit'
                    className='btn btn-success'
                  >
                    {locales('tables.approve')}
                  </button>
                </div>
              </div>
              {!props.editMode && (
                <div className='form-row'>
                  <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex'>
                    <label className='rsee-form-label col-2 text-right'>
                      {locales('added.regions.list')}
                    </label>
                    <div className='d-flex flex-wrap'>
                      {controls.regionsList.map(region => (
                        <span className='border rounded p-1 m-2'>{region}</span>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
        </form>

        <ModalFooter>
          <button
            type='button'
            className='btn'
            onClick={e => {
              handleModal();
              window.location.reload();
            }}
          >
            {locales('close.modal')}
          </button>
        </ModalFooter>
      </Modal>
    </section>
  );
};

export default AddOrEditRegion;
